import { render, staticRenderFns } from "./OverlayEditor.vue?vue&type=template&id=3b825858&scoped=true"
import script from "./OverlayEditor.vue?vue&type=script&lang=js"
export * from "./OverlayEditor.vue?vue&type=script&lang=js"
import style0 from "./OverlayEditor.vue?vue&type=style&index=0&id=3b825858&prod&lang=scss"
import style1 from "./OverlayEditor.vue?vue&type=style&index=1&id=3b825858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b825858",
  null
  
)

export default component.exports